import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY, SALARY_FROM, SALARY_TO } from '../data/siteData';

const TermsPage = () => (
    <div className="page">
        <div className="container page-container">
            <h1 className="page-title">Пользовательское соглашение</h1>

            <div className="page-content legal-content">
                <p>
                    Настоящее Пользовательское соглашение (далее — Соглашение) регулирует отношения между
                    Оператором сайта {COMPANY.siteUrl} (далее — Оператор) и пользователем Сайта.
                </p>

                <h2>1. Предмет соглашения</h2>
                <p>
                    Оператор предоставляет пользователю доступ к информации о вакансиях охраны с вахтовым методом
                    работы и оказывает информационные услуги по подбору персонала. Сайт не является
                    работодателем и не гарантирует трудоустройство.
                </p>

                <h2>2. Информация на сайте</h2>
                <p>
                    Сведения о заработной плате (от {SALARY_FROM.toLocaleString('ru-RU')} до{' '}
                    {SALARY_TO.toLocaleString('ru-RU')} рублей в месяц), условиях работы, проезде и
                    подъёмных носят информационный характер. Точные условия определяются работодателем и
                    оговариваются индивидуально при консультации.
                </p>

                <h2>3. Подача заявки</h2>
                <p>
                    Заполняя форму на Сайте, пользователь подтверждает достоверность указанных данных и
                    даёт согласие на обработку персональных данных в соответствии с{' '}
                    <Link to="/privacy">Политикой конфиденциальности</Link>.
                </p>

                <h2>4. Обязанности пользователя</h2>
                <ul>
                    <li>предоставлять достоверные контактные данные;</li>
                    <li>не использовать Сайт в противоправных целях;</li>
                    <li>не распространять ложную информацию о вакансиях и условиях.</li>
                </ul>

                <h2>5. Ограничение ответственности</h2>
                <p>
                    Оператор не несёт ответственности за действия работодателей-партнёров, за решения о
                    приёме на работу, за фактический размер заработной платы и иные условия трудовых
                    отношений между соискателем и работодателем.
                </p>
                <p>
                    Оператор не гарантирует трудоустройство, наличие конкретных вакансий в указанный срок
                    или соответствие условий ожиданиям пользователя.
                </p>

                <h2>6. Интеллектуальная собственность</h2>
                <p>
                    Все материалы Сайта (тексты, изображения, дизайн) являются объектами интеллектуальной
                    собственности Оператора или используются на законных основаниях. Копирование без
                    согласия Оператора запрещено.
                </p>

                <h2>7. Изменение условий</h2>
                <p>
                    Оператор вправе изменять настоящее Соглашение в одностороннем порядке. Продолжение
                    использования Сайта после публикации изменений означает согласие с новой редакцией.
                </p>

                <h2>8. Контакты</h2>
                <p>
                    По вопросам, связанным с использованием Сайта: {COMPANY.email},{' '}
                    {COMPANY.address}.
                </p>

                <p className="page-note">Дата публикации: 23 июня 2026 г.</p>
            </div>
        </div>
    </div>
);

export default TermsPage;
